import TagFilters from "./TagFilters";
import React from "react";
import I18n from "../I18n";

export default ({...props}) => <TagFilters attribute="category" title={I18n.filters.category}  {...props}/>